import { Grid, Paper} from '@mui/material'
import { FormDescriptionTypographyPDF, FormTitleTypographyPDF } from '../../../../components/CustomStyles/StyledComponents';
import { WHOLE_FARM_DETAILED_TABLES } from '../../../../constants/shellTables';
import DataTable from '../../../../components/Results/ResultsDataTable';

const Tables = ({ results = {} }) => {
    /*
            {
                tableId === 'methaneResults' &&
                <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <Typography variant="caption" paragraph>
                        <sup>†</sup> <em>GWP</em> is an alternative way of reporting methane emissions. Methane breaks
                        down much faster than other greenhouse gasses but has a large upfront
                        warming impact. GWP* aims to capture this effect better than the standard
                        GWP100 metric. When measuring using GWP*, increased methane emissions
                        have a large impact, but steady or declining emissions have a much smaller
                        impact..
                    </Typography>
                </Grid>
            }
        </>
    }
    */
    return (
        <Paper sx={{ maxWidth: '860px', pageBreakAfter: 'always', marginTop: '2mm', borderRadius: 0, }} p={2}>
                <Grid item xs={12}>
                    <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', marginTop: '4mm', borderRadius: 0, }}>
                        <FormTitleTypographyPDF fontSize={20} variant="h6" component="div">
                            Whole Farm Emissions
                        </FormTitleTypographyPDF>
                        <FormDescriptionTypographyPDF variant="body2" fontSize={10} paragraph mb={1}>
                            {`A summary of emissions from carbon dioxide, methane and nitrous oxide for the whole 
                            farm and per enterprise is presented below. Total emissions are also expressed per unit of output, 
                            per hectare and per livestock unit equivalent to allow comparisons to be made. Per unit of output 
                            is the most common way to express emissions associated with the production of food products.`}
                        </FormDescriptionTypographyPDF>
                        <FormDescriptionTypographyPDF variant="body2" fontSize={10} paragraph mb={0}>
                            {`All emissions are expressed as kg CO₂-eq, unless otherwise indicated.`}
                        </FormDescriptionTypographyPDF>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='column'>
                        {Object.entries(WHOLE_FARM_DETAILED_TABLES).map(([tableKey, tableData]) => (
                            <Grid item xs={12} sx={{
                                pageBreakInside: 'avoid'
                            }}>
                                <DataTable
                                    key={tableKey}
                                    tableId={tableKey}
                                    tableData={tableData}
                                    resultsData={results[tableKey]}
                                    media='print' />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Paper>
    )
}

export default Tables